module.exports = __webpack_public_path__ + "img/pa.5e28770b.png";